module.exports = __webpack_public_path__ + "img/about_img05.596d242f.png";